import { Color } from "src/elements/Color/Color";

/** Dividers are drawn in a dark neutral, above product images and highlight overlays. */
export const SHELF_DIVIDER_COLOR = Color.gray800;

/** A divider is never drawn thinner than this on screen, however far the view is zoomed out. */
export const MIN_DIVIDER_SCREEN_PX = 2;

interface ItemHeightLike {
  getHeight: () => number;
  getVerticalFacings: () => number;
  getYCappingHeight: () => number;
}

/** How tall a run's items stand: the tallest product, its vertical facings and caps included. */
export const getRunItemHeight = (items: readonly ItemHeightLike[]): number =>
  items.reduce(
    (tallest, item) =>
      Math.max(tallest, item.getHeight() * item.getVerticalFacings() + item.getYCappingHeight()),
    0,
  );

/**
 * A divider's drawn x span at `scale` (screen px per world unit): its true span, widened about
 * its centre to `MIN_DIVIDER_SCREEN_PX` when the true width would draw thinner. World units in,
 * world units out.
 */
export const getDividerDrawSpan = (x: number, width: number, scale: number) => {
  const minWidth = scale > 0 ? MIN_DIVIDER_SCREEN_PX / scale : width;
  if (width >= minWidth) return { x, width };
  return { x: x + width / 2 - minWidth / 2, width: minWidth };
};

/** DOM renderer: above every layer of an item (facings, images, highlight, overlays, new-item dot). */
export const SHELF_DIVIDER_Z_INDEX = 12;
